module.exports = __webpack_public_path__ + "static/media/back.d78b3434.svg";